"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Asset Data Service API
 * ADS API Service is responsible for managing organization\'s assets
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rswarriors@arcticwolf.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskEnrichmentsToJSON = exports.RiskEnrichmentsFromJSONTyped = exports.RiskEnrichmentsFromJSON = exports.instanceOfRiskEnrichments = void 0;
var runtime_1 = require("../runtime");
var RiskScannedTimestamps_1 = require("./RiskScannedTimestamps");
/**
 * Check if a given object implements the RiskEnrichments interface.
 */
function instanceOfRiskEnrichments(value) {
    var isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "score" in value;
    return isInstance;
}
exports.instanceOfRiskEnrichments = instanceOfRiskEnrichments;
function RiskEnrichmentsFromJSON(json) {
    return RiskEnrichmentsFromJSONTyped(json, false);
}
exports.RiskEnrichmentsFromJSON = RiskEnrichmentsFromJSON;
function RiskEnrichmentsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': json['count'],
        'score': json['score'],
        'highestScore': !(0, runtime_1.exists)(json, 'highest_score') ? undefined : json['highest_score'],
        'lastSuccessfulScanned': !(0, runtime_1.exists)(json, 'last_successful_scanned') ? undefined : (0, RiskScannedTimestamps_1.RiskScannedTimestampsFromJSON)(json['last_successful_scanned']),
    };
}
exports.RiskEnrichmentsFromJSONTyped = RiskEnrichmentsFromJSONTyped;
function RiskEnrichmentsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
        'score': value.score,
        'highest_score': value.highestScore,
        'last_successful_scanned': (0, RiskScannedTimestamps_1.RiskScannedTimestampsToJSON)(value.lastSuccessfulScanned),
    };
}
exports.RiskEnrichmentsToJSON = RiskEnrichmentsToJSON;
